import { chf, soldeClass } from '../utils/format';
import type { Mode } from '../types';

/** Un montant signé : rouge quand la personne doit, vert quand elle a un avoir. */
export function Solde({ valeur }: { valeur: number }) {
  return <span className={soldeClass(valeur)}>{chf(valeur)}</span>;
}

export function Montant({ valeur }: { valeur: number }) {
  return <span className="montant">{chf(valeur)}</span>;
}

export function ModeBadge({ mode, confirme }: { mode: Mode; confirme?: boolean }) {
  return (
    <>
      <span className={`badge mode-badge is-${mode}`}>{mode === 'cash' ? 'Cash' : 'Facture'}</span>
      {confirme === false && <span className="mode-aconfirmer" title="Mode de paiement à confirmer avec la personne">à confirmer</span>}
    </>
  );
}
